let files = []
const requireModule = require.context('@/configurations/templates', true, /\.js$/i, 'sync')

requireModule.keys()
  .filter(fileName => fileName !== './index.js' && !fileName.includes('blocks'))
  .forEach(fileName => files = [...files, ...requireModule(fileName).default])

export default files
